// extracted by mini-css-extract-plugin
module.exports = {"label":"EditProjectField_label_2ESTP","infos":"EditProjectField_infos_38H1d","input":"EditProjectField_input_1MHte","error":"EditProjectField_error_1MTvY"};